module.exports = __webpack_public_path__ + "img/rocket.1c67c385.png";